var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-fa",class:_vm.classes},[_c('svg',{class:_vm.classes,attrs:{"role":"img"}},[_c('use',{attrs:{"href":"/img/svgs/font-awesome.svg#empty"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }